import './App.css';

// React Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';

// React Router Dom
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Pages
import SignIn from './Pages/SignIn';
// Business
import PageDashboardBusiness from './Pages/Dashboard/Business';
import PageFinancesBusiness from './Pages/Finances/Business';
// Transactions
import PageProducts from './Pages/Products';
import PageOrders from './Pages/Orders';
import PageOrdersStore from './Pages/Orders/Store';
import PageOrdersPrint from './Pages/Orders/Print';
// Reports
import PageOrdersRecap from './Pages/Orders/Recap';
import PageFinancesBusinessRecap from './Pages/Finances/Business/Recap';
// Personal
import PageDashboardPersonal from './Pages/Dashboard/Personal';
import PageFinancesPersonal from './Pages/Finances/Personal';
// Reports
import PageFinancesPersonalRecap from './Pages/Finances/Personal/Recap';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<SignIn/>}/>
                {/* Business */}
                <Route path="/business/dashboard" element={<PageDashboardBusiness/>}/>
                <Route path="/business/finances" element={<PageFinancesBusiness/>}/>
                {/* Transactions */}
                <Route path="/products" element={<PageProducts/>}/>
                <Route path="/orders" element={<PageOrders/>}/>
                <Route path="/orders/store" element={<PageOrdersStore/>}/>
                <Route path="/orders/print" element={<PageOrdersPrint/>}/>
                {/* Reports */}
                <Route path="/orders/recap" element={<PageOrdersRecap/>}/>
                <Route path="/business/finances/recap" element={<PageFinancesBusinessRecap/>}/>
                
                {/* Personal */}
                <Route path="/personal/dashboard" element={<PageDashboardPersonal/>}/>
                <Route path="/personal/finances" element={<PageFinancesPersonal/>}/>
                {/* Reports */}
                <Route path="/personal/finances/recap" element={<PageFinancesPersonalRecap/>}/>
            </Routes>
        </Router>
    );
}

export default App;
